import { render, staticRenderFns } from "./cualitativa.vue?vue&type=template&id=327ad9a8&lang=html"
import script from "./cualitativa.vue?vue&type=script&lang=js"
export * from "./cualitativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports